@if (visible$ | async) {
  <section class="mb-16">
    <stb-alert
      [surfaceVariant]="'surface-1'"
      [width]="'fluid'"
      [rebrand]="true"
      [type]="type === types.Error ? 'warning' : 'info'"
      [heading]="getTitle()"
    >
      <ng-content></ng-content>
      <stb-accordion [rebrand]="true">
        <stb-accordion-item [headerText]="footerTitle">
          <div [innerHTML]="footerHtml"></div>
        </stb-accordion-item>
      </stb-accordion>
    </stb-alert>
  </section>
}
